import React from "react";

interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  src: string;
  alt?: string;
  className?: string;
  imgClassName?: string;
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    { src, alt = "icon", className = "", imgClassName = "", onClick, ...rest },
    ref
  ) => (
    <button
      type="button"
      ref={ref}
      onClick={onClick}
      className={`inline-flex items-center justify-center rounded hover:bg-crane-white-10 focus:outline-none ${className}`}
      {...rest}
    >
      <img src={src} alt={alt} className={`w-10 h-10 ${imgClassName}`} />
    </button>
  )
);

IconButton.displayName = "IconButton";
